import React, { useEffect } from "react";
import { PageSummary_SearchRequest } from "../Models/Model";
import { ContainerType, PageType } from "../Models/Enum";
import { SimpleResponse } from "../Models/ResponseModel";
import pageService from "../Services/pageService";
import { Container } from "react-bootstrap";
import { IMAGE_MAIN_ENDPOINT } from "../constant";


function ImageContainer(props) {
    
    function getTemplate() {     
        let Template = 
        <Container className='mb-5 ' >
        <div  className='row justify-content-center align-items-center'> 
            <img className='img-fluid ' src={IMAGE_MAIN_ENDPOINT+props.data} />
        </div>
       </Container>;
   

    if(props.FldMapType == 8){
        Template  =   
        <Container  style={{ top: '170px' }}>
        <div className='row justify-content-center align-items-center'>
            <div className='col-auto'>
                <img className='img-fluid'  src={IMAGE_MAIN_ENDPOINT+ props.data} alt='Mango Trail' />
            </div>
        </div>
       </Container>;        
    }
    
    return Template
}
   
    return <>{getTemplate()}</>  
        
}

export default ImageContainer